import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import { Button, Dialog, DialogTitle, IconButton, Typography } from '@material-ui/core'
import styled from 'styled-components'

export const Modal = styled(Dialog)`
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 0;
  max-width: unset;
  right: 0;
  width: 100%;
  @media (min-width: 600px) : {
    margin: 0 auto;
    position: relative;
    width: 414px;
  }
`

export const ModalHeader = styled.h3`
  color: ${({ theme }) => theme.colors.grayscale.white};
  margin: inherit;
`

export const ModalMessage = styled(Typography)`
  font-size: 16px;
  line-height: 27px;
  margin-bottom: 15px;
`

export const ModalCloseButton = styled(Button)`
  width: calc(100% - 4px);
`

export const ModalActionButton = styled(PrimaryButton)`
  width: calc(100% - 4px);
  margin-right: 8px;
  margin-bottom: 10px;
`

export const ModalCloseIcon = styled(IconButton)`
  color: ${({ theme }) => theme.colors.grayscale.white};
  position: absolute;
  right: 12px;
  top: 12px;
  &.MuiIconButton-root:hover {
    background-color: inherit;
  }
`

export const ModalTitle = styled(DialogTitle)`
  align-items: center;
  display: flex;
  height: 73px;
`

export const TestKitItemMessage = styled(Typography)`
  font-style: italic;
  padding-top: 10px;
`
